export const addFilterSuffix = (filterId, tableId) => {
  if (!tableId || !filterId || filterId.includes("_")) return filterId;
  return `${filterId}_${tableId}`;
};

export const removeFilterSuffix = (suffixedId, tableId) => {
  if (!tableId || !suffixedId || typeof suffixedId !== "string")
    return suffixedId;
  return suffixedId?.replace(`_${tableId}`, "");
};

export const belongsToTable = (filterId, tableId) => {
  if (!tableId || !filterId) return true;
  return filterId.endsWith(`_${tableId}`) || !filterId.includes("_");
};

export const processTableParams = (params, tableId, isForUrl = false) => {
  if (!tableId) return params;

  const { filters, page, pageSize, orderKey, orderDir } = params;

  if (isForUrl) {
    const currentParams = new URLSearchParams(window.location.search);
    const currentTableParams = [];

    currentParams.entries().forEach(([key, value]) => {
      if (!key.includes(`_${tableId}`)) {
        currentTableParams.push({ id: key, value });
      }
    });

    const customParams = {
      page: page || 1,
      pageSize: pageSize || 20,
      orderKey,
      orderDir,
    };

    const ourFilters = [];
    (filters || []).forEach((filter) => {
      ourFilters.push({
        ...filter,
        id: addFilterSuffix(filter.id, tableId),
      });
    });

    return {
      filters: [...currentTableParams, ...ourFilters],
      paramNames: {
        page: addFilterSuffix("page", tableId),
        pageSize: addFilterSuffix("pageSize", tableId),
        orderKey: addFilterSuffix("orderKey", tableId),
        orderDir: addFilterSuffix("orderDir", tableId),
      },
      values: {
        page: customParams.page,
        pageSize: customParams.pageSize,
        orderKey: customParams.orderKey,
        orderDir: customParams.orderDir,
      },
    };
  }

  const customParams = {
    page: null,
    pageSize: null,
    orderKey: null,
    orderDir: null,
  };

  const ourFilters = [];

  (filters || [])
    .filter((filter) => belongsToTable(filter.id, tableId))
    .forEach((filter) => {
      if (
        filter.id === `page_${tableId}` ||
        filter.id === `pageSize_${tableId}` ||
        filter.id === `size_${tableId}` ||
        filter.id === `orderKey_${tableId}` ||
        filter.id === `orderDir_${tableId}`
      ) {
        customParams[removeFilterSuffix(filter.id, tableId)] = filter.value;
      } else {
        ourFilters.push({
          ...filter,
          id: removeFilterSuffix(filter.id, tableId),
        });
      }
    });

  return {
    filters: ourFilters,
    page: page || customParams.page,
    pageSize: pageSize || customParams.pageSize,
    orderKey: orderKey || customParams.orderKey,
    orderDir: orderDir || customParams.orderDir,
  };
};

export const processPageParams = (params, tableId, isForUrl = false) => {
  const { page, pageSize, sort } = params;

  if (!tableId) {
    return {
      paramNames: {
        page: "page",
        pageSize: "pageSize",
        orderKey: "orderKey",
        orderDir: "orderDir",
      },
      values: {
        page,
        pageSize,
        sort,
      },
    };
  }

  if (isForUrl) {
    return {
      paramNames: {
        page: addFilterSuffix("page", tableId),
        pageSize: addFilterSuffix("pageSize", tableId),
        orderKey: addFilterSuffix("orderKey", tableId),
        orderDir: addFilterSuffix("orderDir", tableId),
      },
      values: {
        page,
        pageSize,
        sort,
      },
    };
  }

  return {
    paramNames: {
      page: "page",
      pageSize: "pageSize",
      orderKey: "orderKey",
      orderDir: "orderDir",
    },
    values: {
      page,
      pageSize,
      sort,
    },
  };
};
